var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.005 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.876 3.9L23.1 8.132a.458.458 0 0 1 0 .647l-10.235 10.24-4.351.481a.912.912 0 0 1-1.008-1.008l.483-4.351L18.229 3.9a.458.458 0 0 1 .647 0zm7.6-1.074L24.183.542a1.834 1.834 0 0 0-2.588 0L19.935 2.2a.458.458 0 0 0 0 .647l4.229 4.229a.458.458 0 0 0 .647 0l1.66-1.66a1.834 1.834 0 0 0 0-2.588zM18 16.234v4.773H3V6h10.775a.576.576 0 0 0 .4-.164l1.875-1.875a.563.563 0 0 0-.4-.961H2.25A2.251 2.251 0 0 0 0 5.253v16.5a2.251 2.251 0 0 0 2.25 2.25h16.5A2.251 2.251 0 0 0 21 21.757v-7.4a.564.564 0 0 0-.961-.4l-1.875 1.875a.576.576 0 0 0-.164.402z",
    transform: "translate(0 -.007)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f862010a030be21fd0540e52ddb65c4a.svg";
export { ForwardRef as ReactComponent };